// Single source of truth for listing/request categories.
export const CATEGORIES = [
  "Electronics & Gadgets",
  "Tools & Equipment",
  "Vehicles & Transportation",
  "Outdoor & Sports Gear",
  "Party & Event Supplies",
  "Home & Garden",
  "Musical Instruments",
  "Fashion & Accessories",
  "Other",
] as const;

export type Category = (typeof CATEGORIES)[number];

const ALIASES: Record<string, Category> = {
  electronics: "Electronics & Gadgets",
  cameras: "Electronics & Gadgets",
  camera: "Electronics & Gadgets",
  gaming: "Electronics & Gadgets",
  tools: "Tools & Equipment",
  vehicles: "Vehicles & Transportation",
  outdoor: "Outdoor & Sports Gear",
  sports: "Outdoor & Sports Gear",
  "party equipment": "Party & Event Supplies",
  party: "Party & Event Supplies",
  "lawn & garden": "Home & Garden",
  garden: "Home & Garden",
  home: "Home & Garden",
  music: "Musical Instruments",
  fashion: "Fashion & Accessories",
  "school supplies": "Other",
};

/** Map any legacy/alias category name to its canonical value. */
export const normalizeCategory = (value: string | null | undefined): Category | null => {
  if (!value) return null;
  const exact = CATEGORIES.find((c) => c.toLowerCase() === value.trim().toLowerCase());
  if (exact) return exact;
  return ALIASES[value.trim().toLowerCase()] ?? null;
};

export const categoryHref = (value: string) =>
  `/browse?category=${encodeURIComponent(normalizeCategory(value) ?? value)}`;
